var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 88,
    viewBox: "0 0 75 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_640_16418)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6061 67.4249C44.237 66.6817 41.1002 68.168 37.5944 68.168C34.0886 68.168 30.9518 66.6817 30.5828 67.4249C30.2137 68.168 36.603 76.0006 37.5944 76.0006C38.5858 76.0006 44.9751 68.168 44.6061 67.4249Z",
    fill: "url(#paint0_linear_640_16418)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 49.1892,
    height: 49.1892,
    rx: 24,
    fill: "url(#paint1_linear_640_16418)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 49.1892,
    height: 49.1892,
    rx: 24,
    stroke: "white",
    strokeWidth: 5.27027
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 49.1892,
    height: 49.1892,
    rx: 24,
    stroke: "url(#paint2_linear_640_16418)",
    strokeWidth: 5.27027
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0176 39.75H28.0371C28.5234 39.75 28.8398 39.4746 28.8398 39.0176C28.8398 38.5605 28.5176 38.2852 28.0371 38.2852H24.9023V36.1523H27.8848C28.3301 36.1523 28.623 35.8945 28.623 35.4727C28.623 35.0508 28.3242 34.793 27.8848 34.793H24.9023V32.7598H28.0371C28.5176 32.7598 28.8398 32.4844 28.8398 32.0273C28.8398 31.5703 28.5234 31.2949 28.0371 31.2949H24.0176C23.4609 31.2949 23.1328 31.6348 23.1328 32.2148V38.8242C23.1328 39.4102 23.4609 39.75 24.0176 39.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.502 39.873C33.123 39.873 33.4805 39.6035 33.6973 39L35.332 34.582C35.3848 34.4355 35.4258 34.2598 35.4258 34.1016C35.4258 33.668 35.0684 33.3398 34.5938 33.3398C34.1953 33.3398 33.9082 33.5566 33.791 34.0078L32.5195 38.2383H32.4844L31.2129 34.0254C31.084 33.5625 30.8086 33.3398 30.3926 33.3398C29.9062 33.3398 29.5371 33.6445 29.5371 34.1074C29.5371 34.2832 29.5781 34.4648 29.6309 34.6172L31.2656 39C31.4941 39.6094 31.8457 39.873 32.502 39.873Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.918 39.8848C40.1309 39.8848 41.1035 39.4277 41.5195 38.6543C41.5957 38.5137 41.6367 38.373 41.6367 38.2383C41.6367 37.8457 41.3379 37.6113 40.9688 37.6113C40.7461 37.6113 40.5938 37.6758 40.4121 37.8633C39.9492 38.4082 39.5391 38.6191 38.9121 38.6191C38.0449 38.6191 37.4824 38.0098 37.4824 37.0781V37.002H41.0684C41.543 37.002 41.8125 36.7324 41.8125 36.2578C41.8125 34.5527 40.6172 33.334 38.8359 33.334C36.9785 33.334 35.8008 34.6172 35.8008 36.6387C35.8008 38.6719 36.9551 39.8848 38.918 39.8848ZM37.5 35.9531C37.5586 35.1504 38.1035 34.5996 38.8535 34.5996C39.6035 34.5996 40.1309 35.1328 40.166 35.9531H37.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5527 39.873C44.0566 39.873 44.4082 39.5684 44.4082 38.9824V36.1465C44.4082 35.332 44.8945 34.7695 45.6621 34.7695C46.4297 34.7695 46.8164 35.2383 46.8164 36.0586V38.9824C46.8164 39.5684 47.168 39.873 47.6719 39.873C48.1699 39.873 48.5273 39.5684 48.5273 38.9824V35.7012C48.5273 34.2305 47.7422 33.3516 46.3477 33.3516C45.3809 33.3516 44.748 33.7793 44.4141 34.5586H44.3789V34.207C44.3789 33.668 44.0391 33.3398 43.5234 33.3398C43.0078 33.3398 42.6973 33.668 42.6973 34.2012V38.9824C42.6973 39.5684 43.0547 39.873 43.5527 39.873Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0684 38.1445C50.0684 39.252 50.6484 39.8203 51.791 39.8203H51.8496C52.5703 39.8203 53.0625 39.5625 53.0625 39.0586C53.0625 38.6602 52.834 38.4844 52.4121 38.4375L52.3008 38.4258C51.9316 38.3965 51.7793 38.209 51.7793 37.7637V34.7578H52.3828C52.7871 34.7578 53.0391 34.5059 53.0391 34.1133C53.0391 33.7207 52.7871 33.4688 52.3828 33.4688H51.7793V32.7715C51.7793 32.2207 51.457 31.8809 50.9238 31.8809C50.3906 31.8809 50.0684 32.2207 50.0684 32.7715V33.4688H49.7402C49.3359 33.4688 49.0781 33.7148 49.0781 34.1133C49.0781 34.5117 49.3359 34.7578 49.7402 34.7578H50.0684V38.1445Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_640_16418",
    x: 0.615234,
    y: 0.239746,
    width: 73.959,
    height: 87.1362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_640_16418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_640_16418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_16418",
    x1: 30.5674,
    y1: 67.2168,
    x2: 30.5674,
    y2: 76.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_16418",
    x1: 13,
    y1: 11,
    x2: 13,
    y2: 60.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_640_16418",
    x1: 13,
    y1: 11,
    x2: 13,
    y2: 60.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEvent);
export default __webpack_public_path__ + "static/media/pin_event.2aa11b37e1bb8ba20c5b0073b7118c46.svg";
export { ForwardRef as ReactComponent };